import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ContractorOnboarding() {
  const { user } = useAuth();
  if (!user) return null;
  // Just redirect to portal — that's where uploads live.
  return <Navigate to="/contractor" replace />;
}
